"use client";
import { j as e } from "./index.es16.js";
import { forwardRef as b } from "react";
import { composeClassNames as c } from "./index.es109.js";
import p from "./index.es110.js";
b(
  ({
    label: s,
    value: i,
    placeholder: r,
    onChange: o,
    state: a,
    message: l,
    isDisabled: m,
    ...t
  }, d) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("label", { className: "bl-size-6 bl-display-block", children: [
    s,
    /* @__PURE__ */ e.jsx(
      "textarea",
      {
        ...t,
        ref: d,
        className: c(
          "bl-input",
          a && `bl-input--${a}`,
          "bl-m-t-1",
          "bl-p-y-3"
        ),
        onChange: o,
        value: i,
        disabled: m,
        placeholder: r
      }
    ),
    l && /* @__PURE__ */ e.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ e.jsx(p, { state: a, children: l }) })
  ] }) })
);
//# sourceMappingURL=index.es20.js.map
